/**
 * Number fields are typed, not stepped: the spinner arrows are hidden in CSS
 * (site/_forms.scss), and this stops the mouse wheel from changing the value
 * of a focused number field — easy to do by accident while scrolling the
 * data sheet, and it silently alters amounts.
 *
 * The focused field loses focus on the wheel event; the browser then no
 * longer steps it, and the page scrolls as usual (the event is not
 * cancelled). One listener on the document covers fields added later.
 */
export default class NumberInputWheelController {
  constructor() {
    document.addEventListener('wheel', (event: WheelEvent) => this._onWheel(event), { passive: true });
  }

  private _onWheel(event: WheelEvent): void {
    const target = event.target;
    if (
      target instanceof HTMLInputElement
      && target.type === 'number'
      && document.activeElement === target
    ) {
      target.blur();
    }
  }
}
